module.exports = __webpack_public_path__ + "static/pro-banner5@2x-f77f0c0b513acf5319ad9edba62e89e1.jpg";